module.exports = __webpack_public_path__ + "static/img/logo-small-white.3a36fbf.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/logo-small-white.png
 ** module id = 29
 ** module chunks = 1
 **/